import React from 'react';
import ImgCompressor from './components/ImgCompressor';


function App() {
  return (
    <div>
      <ImgCompressor />
    </div>
  );
}

export default App;
